/* Hex Honeycomb + Neural Network background — homepage only
   © 2026 Mu'amar Fadlil — All Rights Reserved. See LICENSE. */
(function() {
  var section = document.querySelector('.landing-page');
  if (!section) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cv = document.createElement('canvas');
  cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:1;pointer-events:none;';
  section.insertBefore(cv, section.firstChild);

  var ctx = cv.getContext('2d');
  var W, H, pts, raf, revealStartTime = -1;
  var isVisible = true, isTabActive = !document.hidden, isRunning = false;

  /* N=22 nodes (was 45) — O(n²) pairs: 231 vs 990, 76% fewer distance checks.
     MD=160 compensates for lower density so the network stays visually connected. */
  var N = 28, N_HUB = 3, MD = 175, R = 46;

  /* Pre-computed constants */
  var WAVE_MS   = 2000, CELL_MS = 550, SETTLE_MS = 500;
  var cS        = R * 1.5;
  var rS        = R * Math.sqrt(3);
  var CURSOR_SQ = (R * 2.5) * (R * 2.5);

  /* 30fps cap */
  var FRAME_MS = 1000 / 30, lastFrame = -9999;

  /* Parallax / hover state */
  var mouseX = -9999, mouseY = -9999;
  var gridOffX = 0, gridOffY = 0, targetOffX = 0, targetOffY = 0;

  /* Wave particles & settling */
  var waveParticles = [];
  var revealComplete = false, settlingStart = -1, settlingDone = false;

  /* Data packets — small pulses traveling along active connections */
  var packets = [], MAX_PACKETS = 8;

  section.addEventListener('mousemove', function(e) {
    var rect = section.getBoundingClientRect();
    mouseX = e.clientX - rect.left;
    mouseY = e.clientY - rect.top;
    targetOffX = -(mouseX - W / 2) / (W / 2) * 4;
    targetOffY = -(mouseY - H / 2) / (H / 2) * 4;
  });
  section.addEventListener('mouseleave', function() {
    mouseX = -9999; mouseY = -9999;
    targetOffX = 0; targetOffY = 0;
  });

  function resize() {
    W = cv.width  = section.offsetWidth;
    H = cv.height = section.offsetHeight;
  }

  /* ── THE RADIANT REVEAL ─────────────────────────────────────────────── */
  function drawHexGrid(t, dt) {
    if (revealStartTime < 0) revealStartTime = t;
    var elapsed = t - revealStartTime;

    var lp = 1 - Math.pow(0.94, dt);
    gridOffX += (targetOffX - gridOffX) * lp;
    gridOffY += (targetOffY - gridOffY) * lp;

    var waveX = ((elapsed / WAVE_MS) * (W + R * 4)) - R * 2;

    if (!revealComplete && elapsed >= WAVE_MS + CELL_MS) {
      revealComplete = true;
      settlingStart  = t;
    }

    ctx.save();
    ctx.translate(gridOffX, gridOffY);

    for (var col = -1; col * cS < W + R; col++) {
      var offY = (col % 2 !== 0) ? rS / 2 : 0;
      for (var row = -1; row * rS + offY < H + R; row++) {
        var cx = col * cS, cy = row * rS + offY;
        if (cx < -R || cx > W + R || cy < -R || cy > H + R) continue;

        var hitTime = ((cx + R * 2) / (W + R * 4)) * WAVE_MS;
        var cellAge = elapsed - hitTime;
        if (cellAge < 0) continue;

        var progress = Math.min(cellAge / CELL_MS, 1);
        var eased    = 1 - Math.pow(1 - progress, 3);
        var scale    = eased;
        if (scale < 0.01) continue;

        var jx = 0, jy = 0;
        if (!settlingDone && revealComplete && settlingStart > 0) {
          var se = t - settlingStart;
          if (se < SETTLE_MS) {
            var sa   = 1 - se / SETTLE_MS;
            var seed = (col * 7.3 + row * 13.7) % 100;
            jx = Math.sin(se * 0.05 + seed) * sa;
            jy = Math.cos(se * 0.05 + seed * 1.4) * sa;
          } else {
            settlingDone = true;
          }
        }

        var dx = cx + gridOffX - mouseX, dy = cy + gridOffY - mouseY;
        var nearCursor = dx * dx + dy * dy < CURSOR_SQ;

        ctx.save();
        ctx.globalAlpha = eased;
        ctx.translate(cx + jx, cy + jy);
        ctx.scale(scale, scale);

        ctx.beginPath();
        for (var vi = 0; vi < 6; vi++) {
          var ang = Math.PI / 3 * vi;
          ctx.lineTo(R * Math.cos(ang), R * Math.sin(ang));
        }
        ctx.closePath();

        var cellGrad = ctx.createLinearGradient(-R, 0, R, 0);
        cellGrad.addColorStop(0, 'rgba(200, 255, 0, 0.12)');
        cellGrad.addColorStop(1, 'rgba(0, 150, 0, 0.02)');
        ctx.fillStyle = cellGrad;
        ctx.fill();

        var dewGrad = ctx.createRadialGradient(0, 0, 0, 0, 0, R * 0.6);
        dewGrad.addColorStop(0, 'rgba(200, 255, 0, 0.06)');
        dewGrad.addColorStop(1, 'rgba(200, 255, 0, 0)');
        ctx.fillStyle = dewGrad;
        ctx.fill();

        if (cellAge < 600) {
          var flash = Math.pow(1 - cellAge / 600, 1.5);
          ctx.fillStyle = 'rgba(200, 255, 100, ' + (flash * 0.25) + ')';
          ctx.fill();
        }

        if (nearCursor) {
          ctx.shadowColor = 'rgba(200, 255, 0, 0.15)';
          ctx.shadowBlur  = 6;
        }
        ctx.strokeStyle = 'rgba(200, 255, 0, ' + (nearCursor ? 0.35 : 0.2) + ')';
        ctx.lineWidth   = 0.5 / scale;
        ctx.stroke();
        if (nearCursor) { ctx.shadowColor = 'transparent'; ctx.shadowBlur = 0; }

        ctx.restore();
      }
    }

    ctx.restore();

    if (elapsed < WAVE_MS + 300) {
      var waveFade = elapsed < WAVE_MS ? 1 : 1 - (elapsed - WAVE_MS) / 300;

      var haloGrad = ctx.createLinearGradient(waveX - 160, 0, waveX + 30, 0);
      haloGrad.addColorStop(0,    'rgba(200, 255, 0, 0)');
      haloGrad.addColorStop(0.6,  'rgba(200, 255, 0, 0)');
      haloGrad.addColorStop(0.88, 'rgba(200, 255, 0, 0.08)');
      haloGrad.addColorStop(1,    'rgba(200, 255, 0, 0)');

      var edgeGrad = ctx.createLinearGradient(waveX - 18, 0, waveX + 18, 0);
      edgeGrad.addColorStop(0,    'rgba(200, 255, 0, 0)');
      edgeGrad.addColorStop(0.35, 'rgba(200, 255, 0, 0.06)');
      edgeGrad.addColorStop(0.72, 'rgba(200, 255, 0, 0.15)');
      edgeGrad.addColorStop(1,    'rgba(200, 255, 0, 0)');

      ctx.save();
      ctx.globalAlpha = waveFade;
      ctx.globalCompositeOperation = 'lighter';
      ctx.fillStyle = haloGrad;
      ctx.fillRect(waveX - 160, 0, 190, H);
      ctx.fillStyle = edgeGrad;
      ctx.fillRect(waveX - 18, 0, 36, H);
      ctx.restore();
    }

    if (elapsed > 50 && elapsed < WAVE_MS && Math.random() < 0.3 * dt) {
      waveParticles.push({
        x: waveX + (Math.random() - 0.5) * 20,
        y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.5,
        vy: (Math.random() - 0.5) * 0.5,
        life: 1,
        decay: 0.007 + Math.random() * 0.005,
        r: Math.random() * 1.5 + 0.5
      });
    }

    for (var wi = waveParticles.length - 1; wi >= 0; wi--) {
      var wp = waveParticles[wi];
      wp.x += wp.vx * dt; wp.y += wp.vy * dt;
      wp.life -= wp.decay * dt;
      if (wp.life <= 0) { waveParticles.splice(wi, 1); continue; }
      ctx.beginPath();
      ctx.arc(wp.x, wp.y, wp.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(200, 255, 0, ' + (wp.life * 0.7) + ')';
      ctx.fill();
    }

    var scanFade = Math.max(0, Math.min((elapsed - (WAVE_MS + 200)) / 900, 1));
    if (scanFade > 0) {
      var scanX    = (t / 35) % (W + 2000) - 1000;
      var scanGrad = ctx.createLinearGradient(scanX, 0, scanX + 800, 0);
      scanGrad.addColorStop(0,   'rgba(200, 255, 0, 0)');
      scanGrad.addColorStop(0.5, 'rgba(200, 255, 0, ' + (0.22 * scanFade) + ')');
      scanGrad.addColorStop(1,   'rgba(200, 255, 0, 0)');
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      ctx.fillStyle = scanGrad;
      ctx.fillRect(scanX, 0, 800, H);
      ctx.restore();
    }
  }

  /* ── NODE CONSTRUCTOR ───────────────────────────────────────────────── */
  function Pt(isHub) {
    this.isHub = !!isHub;
    this.x     = Math.random() * W;
    this.y     = Math.random() * H;
    /* Hubs move slower — they act as stable anchor points */
    var spd    = isHub ? 0.18 : 0.4;
    this.vx    = (Math.random() - 0.5) * spd;
    this.vy    = (Math.random() - 0.5) * spd;
    /* Hubs are visibly larger */
    this.r     = isHub ? Math.random() * 1.5 + 3.5 : Math.random() * 1.2 + 1;
    this.phase = Math.random() * Math.PI * 2;

    /* Orbit mode only for regular nodes */
    this.orbitMode = !isHub && Math.random() < 0.3;
    if (this.orbitMode) {
      this.ox      = this.x;
      this.oy      = this.y;
      this.oRadius = 10 + Math.random() * 10;
      this.oAngle  = Math.random() * Math.PI * 2;
      this.oSpeed  = (Math.random() < 0.5 ? 1 : -1) * (0.01 + Math.random() * 0.015);
    }
  }

  Pt.prototype.move = function(dt) {
    if (this.orbitMode) {
      this.oAngle += this.oSpeed * dt;
      this.x = this.ox + Math.cos(this.oAngle) * this.oRadius;
      this.y = this.oy + Math.sin(this.oAngle) * this.oRadius;
      this.ox += (Math.random() - 0.5) * 0.08 * dt;
      this.oy += (Math.random() - 0.5) * 0.08 * dt;
      if (this.ox < R)     this.ox = R;
      if (this.ox > W - R) this.ox = W - R;
      if (this.oy < R)     this.oy = R;
      if (this.oy > H - R) this.oy = H - R;
    } else {
      this.x += this.vx * dt;
      this.y += this.vy * dt;
      if (this.x < 0 || this.x > W) this.vx = -this.vx;
      if (this.y < 0 || this.y > H) this.vy = -this.vy;
    }
  };

  /* ── INIT ───────────────────────────────────────────────────────────── */
  function init() {
    resize();
    revealStartTime = -1;
    revealComplete  = false;
    settlingStart   = -1;
    settlingDone    = false;
    waveParticles   = [];
    packets         = [];
    pts = [];
    /* First N_HUB nodes are hubs, the rest are regular */
    for (var i = 0; i < N_HUB; i++)       pts.push(new Pt(true));
    for (var j = 0; j < N - N_HUB; j++)   pts.push(new Pt(false));
  }

  function shouldRun() {
    return isVisible && isTabActive;
  }

  function start() {
    if (isRunning || !shouldRun()) return;
    isRunning = true;
    lastFrame = -9999;
    raf = requestAnimationFrame(draw);
  }

  function stop() {
    if (!isRunning) return;
    isRunning = false;
    cancelAnimationFrame(raf);
  }

  /* ── DRAW LOOP ──────────────────────────────────────────────────────── */
  function draw(timestamp) {
    if (!isRunning) return;
    raf = requestAnimationFrame(draw);
    if (!shouldRun()) { stop(); return; }

    var dt = Math.min((timestamp - (lastFrame < 0 ? timestamp - 16.67 : lastFrame)) / 16.67, 3);
    if (lastFrame > 0 && timestamp - lastFrame < FRAME_MS) return;
    lastFrame = timestamp;

    ctx.clearRect(0, 0, W, H);
    drawHexGrid(timestamp, dt);

    var i, j, p;
    for (i = 0; i < pts.length; i++) pts[i].move(dt);

    /* ── BUILD EDGE LIST ──────────────────────────────────────────────
       O(n²) with n=22 → max 231 pairs (vs 990 with n=45 before).
       Quadratic falloff gives smooth fade-in as nodes approach,
       not an abrupt cutoff at threshold. Sorted by distance so
       the connection-count cap always preserves the closest edges. */
    var candidates = [];
    for (i = 0; i < pts.length; i++) {
      for (j = i + 1; j < pts.length; j++) {
        var ndx = pts[i].x - pts[j].x;
        var ndy = pts[i].y - pts[j].y;
        var d   = Math.sqrt(ndx * ndx + ndy * ndy);
        if (d < MD) candidates.push({ i: i, j: j, d: d, t: Math.pow(1 - d / MD, 2) });
      }
    }
    candidates.sort(function(a, b) { return a.d - b.d; });

    /* Cap: regular nodes ≤ 3 connections, hub nodes ≤ 4 */
    var connCount = new Array(pts.length).fill(0);
    var edges = [];
    for (var ci = 0; ci < candidates.length; ci++) {
      var c    = candidates[ci];
      var limI = pts[c.i].isHub ? 5 : 4;
      var limJ = pts[c.j].isHub ? 5 : 4;
      if (connCount[c.i] < limI && connCount[c.j] < limJ) {
        edges.push(c);
        connCount[c.i]++;
        connCount[c.j]++;
      }
    }

    /* ── DRAW CONNECTIONS — two passes for glow + core ────────────────
       Pass 1 (glow): wide, very transparent — creates a soft aura.
       Pass 2 (core): thin, opaque — crisp visible line.
       No createLinearGradient per edge; two solid strokes look richer. */
    var e;
    ctx.lineWidth = 3;
    for (i = 0; i < edges.length; i++) {
      e = edges[i];
      ctx.globalAlpha = e.t * 0.10;
      ctx.strokeStyle = 'rgba(160, 240, 0, 1)';
      ctx.beginPath();
      ctx.moveTo(pts[e.i].x, pts[e.i].y);
      ctx.lineTo(pts[e.j].x, pts[e.j].y);
      ctx.stroke();
    }
    ctx.lineWidth = 0.8;
    for (i = 0; i < edges.length; i++) {
      e = edges[i];
      ctx.globalAlpha = e.t * 0.55;
      ctx.strokeStyle = 'rgba(190, 255, 20, 1)';
      ctx.beginPath();
      ctx.moveTo(pts[e.i].x, pts[e.i].y);
      ctx.lineTo(pts[e.j].x, pts[e.j].y);
      ctx.stroke();
    }
    ctx.globalAlpha = 1;

    /* ── DATA PACKETS ─────────────────────────────────────────────────
       Small glowing dots that travel along active connections.
       Spawn probability is dt-corrected so rate is frame-rate independent.
       Each packet fades in for the first 1/6 of its journey and fades
       out for the last 1/6, so it appears to emerge from one node and
       dissolve into the next. */
    if (packets.length < MAX_PACKETS && edges.length > 0 && Math.random() < 0.025 * dt) {
      var pick = edges[Math.floor(Math.random() * edges.length)];
      var fwd  = Math.random() < 0.5;
      packets.push({
        ni:    fwd ? pick.i : pick.j,
        nj:    fwd ? pick.j : pick.i,
        t:     0,
        speed: 0.008 + Math.random() * 0.007
      });
    }

    for (var pi = packets.length - 1; pi >= 0; pi--) {
      var pkt = packets[pi];
      pkt.t += pkt.speed * dt;
      if (pkt.t >= 1) { packets.splice(pi, 1); continue; }

      var px   = pts[pkt.ni].x + (pts[pkt.nj].x - pts[pkt.ni].x) * pkt.t;
      var py   = pts[pkt.ni].y + (pts[pkt.nj].y - pts[pkt.ni].y) * pkt.t;
      /* life: 0→1 over first 1/6, held at 1, 1→0 over last 1/6 */
      var life = Math.min(pkt.t * 6, (1 - pkt.t) * 6, 1);

      /* Outer glow */
      ctx.beginPath();
      ctx.arc(px, py, 5, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(200, 255, 0, ' + (life * 0.18) + ')';
      ctx.fill();

      /* Bright core dot */
      ctx.beginPath();
      ctx.arc(px, py, 2, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(220, 255, 80, ' + (life * 0.90) + ')';
      ctx.fill();
    }

    /* ── DRAW NODES ───────────────────────────────────────────────────
       Hub nodes get an extra outer diffuse ring and are brighter.
       All nodes pulse ±10% in radius with their individual phase offset. */
    for (i = 0; i < pts.length; i++) {
      p = pts[i];
      var pr = p.r * (1 + Math.sin(timestamp * 0.002 + p.phase) * 0.1);

      if (p.isHub) {
        /* Outermost diffuse ring — gives hub nodes a "field of influence" feel */
        ctx.beginPath();
        ctx.arc(p.x, p.y, pr * 4.5, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(200, 255, 0, 0.035)';
        ctx.fill();
      }

      /* Mid glow — hubs are noticeably brighter */
      ctx.beginPath();
      ctx.arc(p.x, p.y, pr * (p.isHub ? 3.0 : 2.2), 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(200, 255, 0, ' + (p.isHub ? 0.13 : 0.07) + ')';
      ctx.fill();

      /* Solid core */
      ctx.beginPath();
      ctx.arc(p.x, p.y, pr, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(210, 255, 20, ' + (p.isHub ? 1.0 : 0.85) + ')';
      ctx.fill();
    }
  }

  window.addEventListener('resize', function() {
    cancelAnimationFrame(raf);
    lastFrame = -9999;
    packets   = [];
    init();
    start();
  });

  document.addEventListener('visibilitychange', function() {
    isTabActive = !document.hidden;
    if (shouldRun()) start();
    else stop();
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      isVisible = entries[0] ? entries[0].isIntersecting : true;
      if (shouldRun()) start();
      else stop();
    }, { threshold: 0 }).observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); start(); });
  } else {
    init(); start();
  }
})();
